import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PunchNotificationCardComponent } from './punch-notification-card/punch-notification-card.component';
import { NotificationContainerComponent } from './notification-container.component';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [NotificationContainerComponent, PunchNotificationCardComponent],
  imports: [CommonModule, StatusCircleModule, MatMiniFabButton, MatIconModule],
  exports: [NotificationContainerComponent],
})
export class NotificationsModule {}
